
<template>
  <div class="BulkOrderbysea" style="
      background: #ffffff;
      box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
      border-radius: 10px;
    ">
    <h4>
      线路订阅
      <el-tooltip class="item" effect="dark" placement="right">
        <div slot="content" style="position: relative">
          <span>
            订阅国家或者产品线路后,
            可以接收线路价格变动或者国家渠道变动通知。
          </span>
          <br />
        </div>
        <span style="font-size: 14px; color: #f9a123; position: relative; top: -3px" class="el-icon-question"></span>
      </el-tooltip>
    </h4>
    <div class="invoiceDesc" v-if="!isBindedWebOpenId">
      <!-- <div class="invoiceDesc"> -->
      <span>
        未收到已收藏的物流产品消息推送？去
        <span style="color: #FF4D01; cursor: pointer" @click="handleInfo">安全设置</span>绑定微信，以及在微信搜索【货代拼】公众号并关注，订阅国家或者产品线路后,
        线路价格变动或者国家渠道变动会第一时间会在微信推送给您。
      </span>
    </div>
    <div class="collect-body">
      <div class="unfollowAll" v-if="activeName === 'second'" @click="handleCancelAll">取消全部订阅</div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane name="first">
          <span slot="label">
            <div class="label-1">
              <img class="imgs" :src="ossPath + '/pages/home/style_take_order.png'" alt />
              <span>国家</span>
            </div>
          </span>
          <div style="display: flex;align-items: center;margin-bottom: 20px;" v-if="realNameState === 3">
            <span style="margin-right: 20px;">是否订阅上新国家推送</span>
            <el-switch v-model="isSubscribeNewCountry" size="medium" :width="50" style="margin-right: 5px;"
              @change="toggleIsSubscribeCountryStatus"></el-switch>
            <el-tooltip class="item" effect="dark" placement="right">
              <div slot="content" style="position: relative">
                <span>
                  开启订阅后，绑定微信并关注货代拼公众号，或绑定了邮箱；平台有上新国家，将会第一时间推送通知给您。
                </span>
                <br />
              </div>
              <span style="font-size: 14px; color: #f9a123;" class="el-icon-question"></span>
            </el-tooltip>
          </div>
          <div class="collect-one" v-if="this.hotcityLIst.length > 0">
            <div class="hotlist" style="width: 100%; overflow: hidden">
              <div class="Hotcounter" @mouseover="changeimg(item), (setColor = index)"
                @mouseleave="mouseLeave(item), (setColor = -1)" style="cursor: pointer"
                v-for="(item, index) in hotcityLIst" :key="index" @click="setHotcity(item, false)">
                <el-card class="SlowAlterBac" shadow="hover" style="height: 140px; width: 100%; border-radius: 30px">
                  <div class style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    ">
                    <div style="min-width: 40px">
                      <img style="max-width: 100%; max-height: 80px" :src="item.picUrl||defaultIcon" alt="国家" />
                    </div>
                    <div style="
                        min-width: 110px;
                        padding-left: 20px;
                        box-sizing: border-box;
                        color: #303133;
                      ">
                      <div style="
                          margin-bottom: 10px;
                          font-size: 18px;
                          font-weight: bold;
                          width: 136px;
                        ">
                        {{ item.countryNamec }}
                        <!--                         <span-->
                        <!--                          class="el-icon-star-off"-->
                        <!--                          style="float: right; font-size: 20px"-->
                        <!--                          @click.stop="followItem(item)"-->
                        <!--                        ></span>-->
                      </div>

                      <div style="
                          font-size: 14px;
                          height: 14px;
                          font-weight: bold;
                          color: rgb(185, 57, 71);
                        ">
                        {{ item.currency }}
                        <span v-show="item.lowestPrice" style="font-size: 14px; color: rgb(185, 57, 71)">
                          <span style="font-size: 18px">
                            {{
                              item.lowestPrice
                            }}
                          </span>
                          /{{ item.chargeType }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <!--                   显示查看国家专线-->
                  <div class="look-info" @click.stop="checkPrice(item)">
                    <div class="look-all">
                      <img src="@/assets/eye.png" alt />
                      <span style="margin-left: 10px">查看国家专线</span>
                    </div>
                  </div>
                  <!--                   显示收藏点击取消-->
                  <div class="cancel-collect" @click.stop="handleCancelCollect(item)">
                    <img src="@/assets/icon_collect_pre.png" alt />
                  </div>
                </el-card>
              </div>
            </div>
          </div>
          <div class="no-data" v-else>
            <div class="content">
              <img src="@/assets/collect.png" alt />
            </div>
            <div class="content">
              <span>暂无收藏内容~</span>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="second">
          <span slot="label">
            <div class="label-1">
              <img class="imgs" style="width: 25px; height: 25px" :src="ossPath + '/pages/home/bcinfo_take_order.png'" alt />
              <span>物流产品</span>
            </div>
          </span>
          <div class="collect-one">
            <!-- &lt;!&ndash; 搜索 &ndash;&gt; -->
            <div style="display: flex; flex-wrap: wrap; margin-top: 20px" v-if="false">
              <div class="grid-content bg-purple" style="
                  margin-bottom: 10px;
                  min-width: 300px;
                  margin-right: 20px;
                  display: flex;
                  align-items: center;
                ">
                <span class="base-form-label" style="margin-right: 20px">
                  <!-- &lt;!&ndash; 流水号 &ndash;&gt; -->
                  专线渠道名称
                </span>
                <el-select v-model="product" placeholder="专线渠道名称" clearable filterable>
                  <el-option v-for="(item, i) in seleProductNameList" :key="i" :label="item.productName"
                    :value="item.productName" @change="getSelectNameList()">
                  </el-option>
                </el-select>
                <!-- &lt;!&ndash; @clear="getkeyup"  &ndash;&gt; -->
              </div>
              <div class="grid-content bg-purple" style="
                  margin-bottom: 10px;
                  min-width: 300px;
                  margin-right: 20px;
                  display: flex;
                  align-items: center;
                ">
                <span class="base-form-label" style="margin-right: 20px">
                  <!-- &lt;!&ndash; 流水号 &ndash;&gt; -->
                  收藏时间
                </span>
                <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="concernTime" type="daterange"
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
              </div>
              <div class="grid-content bg-purple" style="
                  margin-bottom: 10px;
                  min-width: 300px;
                  margin-right: 20px;
                  display: flex;
                  align-items: center;
                ">
                <span class="base-form-label" style="margin-right: 20px">
                  <!-- &lt;!&ndash; 流水号 &ndash;&gt; -->
                  专线渠道代码
                </span>
                <el-select v-model="productCode" placeholder="专线渠道代码" clearable filterable @keyup.enter.native="getkeyup"
                  @change="getSelectCodeList">
                  <el-option v-for="(item, i) in seleProductCodeList" :key="i" :label="item.productCode"
                    :value="item.productCode">
                  </el-option>
                </el-select>

                <!-- &lt;!&ndash;  @clear="getkeyup" &ndash;&gt; -->
              </div>
              <div class="grid-content bg-purple" style="min-width: 285px">
                <el-button @click="handleSerach()" style="margin-left: 20px" type="primary">查询</el-button>
                <el-button type="primary" style="
                    background: white;
                    border: 1px solid #FF4D01;
                    color: #FF4D01;
                    margin-left: 20px;
                  " @click="handleReset">重置</el-button>
              </div>
            </div>
            <!-- &lt;!&ndash; 展示信息 &ndash;&gt; -->
            <!-- <div class="collect-info">
              <el-button @click="handleCancelAll()" style="margin: 20px 0px" type="primary">取消全部收藏</el-button>
              <el-button v-if="product" type="text" @click="handleSerach()" style="margin-left: 20px; color: #333">
                关于"{{ product }}"查询结果,共&nbsp;
                <span style="color: #FF4D01">{{ total }}</span>&nbsp;条收藏
              </el-button>
            </div> -->
            <!-- &lt;!&ndash; 主题内容 &ndash;&gt; -->
            <div class="collect-body-all" v-if="productList.length > 0">
              <collectLineItem
                v-for="(item, index) in productList"
                :key="index"
                :data="item"
                @unfollowItem="handleCancelProductCollect"
                @detail="showText"></collectLineItem>
            </div>
            <div class="no-data" v-else>
              <div class="content">
                <img src="@/assets/collect.png" alt />
              </div>
              <div class="content">
                <span>暂无收藏内容~</span>
              </div>
            </div>
            <!-- &lt;!&ndash; 分页 &ndash;&gt; -->
            <el-pagination style="margin-top: 20px; float: right" @size-change="handleSizeChange"
              @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 查看详情 -->
    <!-- <el-dialog width="1200px" :visible.sync="ProgType" :close-on-click-modal="false">
      <GetitemBill :countData="countData" :theadData="theadData" :tableData="tableData" :BillItem="BillItem"
        :payType="payType" :type="ProgType" :val="typeTips" @getProductData="getProductData"></GetitemBill>
    </el-dialog> -->
    <!-- <el-dialog width="1200px" :visible.sync="ProgType" :close-on-click-modal="false" :append-to-body="true">
      <GetitemBill :countData="countData" :theadData="theadData" :tableData="tableData" v-if="ProgType"
        :deliveryTheadData="deliveryTheadData" :deliveryTableData="deliveryTableData" :BillItem="BillItem"
        :payType="payType" :type="ProgType" :val="typeTips" @getProductData="getProductData"></GetitemBill>
    </el-dialog> -->
    
    <!-- 查价详情-->
    <line-product-detail
      :visible.sync="ProgType"
      :countData="countData"
      :theadData="theadData"
      :tableData="tableData"
      :deliveryTheadData="deliveryTheadData"
      :deliveryTableData="deliveryTableData"
      :BillItem="BillItem"
      :payType="payType"
      :type="ProgType"
      :val="typeTips"
      :podlandType="countData.isFBA ? 1 : 2"
      :is-transfer="!!BillItem.domDTO"
    ></line-product-detail>
    <DeliveryTrail :groupInfo="tailsData" :visible="trailVisible" @close="trailVisible = false" />

    <cannot-place-order :show.sync="showCannotPlaceOrder" :servicePicUrl="servicePicUrl"></cannot-place-order>
  </div>
</template>

<script>
import GetitemBill from "../../placeOrder/placeindexInfo/GetitemBill.vue"
import lineProductDetail from "../../placeOrder/placeindexInfo/lineProductDetail.vue";
import { qrCodeImages } from "../../../../devParams.js";
import {sendCustomerOperationRecord} from "../../../assets/js/utils";
import {ossPath} from "../../../../devParams";
import DeliveryTrail from "@/components/placeOrder/components/deliveryTrail";
import { mapGetters } from "vuex";
import collectLineItem from "./components/collectLineItem.vue";
import CannotPlaceOrder from "../../../../common/cannot-place-order.vue"

export default {
  name: "MyCollect",
  components: {
    GetitemBill,
    lineProductDetail,
    DeliveryTrail,
    collectLineItem,
    CannotPlaceOrder
  },
  data() {
    return {
      defaultIcon:ossPath + "/pages/home/hot_country_default_icon.png",
      agingType: {
        1: '开船后开始计算时效',
        2: '入仓后开始计算时效'
      },
      qrCodeImages,
      concernTime: [],
      productCode: "",
      tableData: [],
      countData: {},
      theadData: [],
      BillItem: {},
      payType: false,
      ProgType: false,
      typeTips: 2, //
      productList: [], // 物流产品
      seleProductNameList: [],//下拉框名称
      seleProductCodeList: [],//下拉框code
      productAll: [], // 物流产品全部数据
      activeName: "first",
      // activeName: "second",
      product: "", // 物流产品
      currentPage: 1,
      pageSize: 10,
      total: 0,
      hotcityLIst: [], // 收藏国家
      setColor: -1,
      isBindedWebOpenId: "",
      isSubscribeNewCountry: false, // 是否订阅上新国家推送
      deliveryTheadData: [],
      deliveryTableData: [],
      endPoi: null,
      tailsData: {},
      trailVisible: false,
      showCannotPlaceOrder: false,
      servicePicUrl: ''
    }
  },
  watch: {
    product() {
      this.getProductData(this.product)
    }
  },
  computed: {
    ...mapGetters(["realNameType","realNameState","token"]),
  },
  created() {
    if(this.$route.query.type) {
      this.activeName = this.$route.query.type
      this.handleClick(this.activeName)
    } else {
      this.getInit()
      this.getSelectNameList()
      this.getSelectCodeList()
    }
  },
  mounted() {

    this.getIsSubscribeCountryStatus()
    // this.getHotcity();
    this.getProductData("")
    let data = JSON.parse(localStorage.getItem("Authorization"))
    this.isBindedWebOpenId = data.isBindedWebOpenId
    // if (this.realNameType === 1) {
    //   this.activeNName = 'first'
    // } else {
    //   this.activeName = 'second'
    // }
    this.getStoreid()
  },

  methods: {
    handleTrail(val) {
      console.log(val)
      this.tailsData = val
      this.trailVisible = true
    },
    getStoreid(item, index, index1, item2, val) {
      console.log(item,'555555555555');
      this.endPoi = item
    },
    getUsertypeRap(item, store) {
      console.log("去下单？？",item);
      if (!this.token) {
        this.$root.Bus.$emit("showDialog", 0, true);
        return
      }
      this.servicePicUrl = item.wxUrl
      this.showCannotPlaceOrder = true
      return
      if (store) {
        console.log('1');
        sessionStorage.setItem("toFABck", JSON.stringify(store));
      }
      if (item.countryName) {
        console.log('2');
        this.endPoi=item.countryName
        console.log(this.endPoi);
        sessionStorage.setItem("toFABck", JSON.stringify(this.endPoi))
      }
      if (!this.sessionGetUserInfo().token) {
        console.log('3');

        this.$root.Bus.$emit("showDialog", 0, true);
      } else {
        console.log('4');

        sendCustomerOperationRecord("去下单",`产品名称:${item.productName}`, { productId: item.productId })
        let customerId = this.sessionGetUserInfo().customerid;
        this.axios
          .get(`/corporation/checkCustomerIsAvailable/${customerId}`)
          .then((res) => {
            if (res.data.code == 200) {
              this.handleNewClick(item);
            } else {
              return this.$message({
                message: "该账号暂未通过审核，请联系客服人员",
                type: "warning",
                offset: "500",
              });
            }
          })
          .catch((res) => {});
      }
    },
    handleNewClick(item) {
      this.ProgType = false
      //去下单
      let tuoCheDataChecked = false;
      sessionStorage.setItem("goodsTypeName", JSON.stringify(item.goodstype));
      sessionStorage.setItem("itemWrap", JSON.stringify(item));
      sessionStorage.setItem("transportTypeCode",item.transportTypeCode);
      sessionStorage.removeItem("countLIst_T");
      if (item.chargeType !== 1) {
      // if ( this.warehouseTypeCurrent === "private" || this.toStoreid === -1 || item.chargeType !== 1) {
      // if (this.tostoreName == "私人地址") {
        sessionStorage.setItem("isPrivate", JSON.stringify(true));
        this.$router.push({
          name: "privateBill",
          query: {
            THFtype: tuoCheDataChecked,
            transportTypeCode: item.transportTypeCode,
            productPriceHeaderId: item.productPriceHeaderId,
            supplierId: item.carrierId ? item.carrierId : '',
            toCountryid: this.toCountryid,
            toCityId: this.toStoreid,
            itemWrap: item,
            postcode: this.toStoreid
          },
        });
      } else {
        sessionStorage.setItem("isPrivate", JSON.stringify(false));
        console.log('xxxxxxxxxxxxx', item)
        this.$router.push({
          name: "newBillCargo",
          query: {
            THFtype: tuoCheDataChecked,
            transportTypeCode: item.transportTypeCode,
            productPriceHeaderId: item.productPriceHeaderId,
            supplierId: item.carrierId ? item.carrierId : '',
            toCountryid: this.toCountryid,
            itemWrap: item,
          },
        });
      }
    },
    setDeliveryPrices() {
      // deliveryRegionPrices
      if (!this.countData.deliveryRegionPrices) {
        this.deliveryTheadData = []
        this.deliveryTableData = []
        return false
      }
      this.deliveryTheadData = this.countData.deliveryRegionPrices[0].map((c, i) => {
        return {
          label: c,
          prop: "name" + i,
        };
      });
      console.log("99999---", this.deliveryTheadData);
      let tableData = [];
      let list = this.countData.deliveryRegionPrices.map(item => item)
      list.splice(0, 1)
      // this.sortQuotationList(list);
      list.forEach((item, index) => {
        let obj = {};
        item.map((_item, index) => {
          obj["name" + index] = _item;
        });
        tableData.push(obj);
      });
      this.deliveryTableData = tableData;
      // this.deliveryTableData.splice(0, 1);
      console.log("tableData", this.deliveryTableData);
    },
    setType(key) {
      const options = {
        ZT: '自提',
        KP: '卡派',
        HK: '海卡',
        HP: '海派',
        WC: '整柜直送',
        FP: '空派',
        KK: '空卡',
        KDP: '快递派',
        KH: '卡航',
        TL: '铁路',
        empty: '-'
      }
      return options[key]
    },
    showText(item, type, val) {
      console.log("item---", item)
      this.typeTips = val
      this.payType = type

      let url = ""
      url = `/FBAfee/queryQuotedPriceDetailInfo?productPriceHeaderId=${item.productPriceHeaderId}`
      this.axios
        .get(url)
        .then((res) => {
          this.ProgType = true
          this.countData = res.data.data
          let labelList = [
            { label: item.pickUpFlag ? '免费上门提货' : '', desc: '' },
            { label: item.goodsMeasurementMethod === 1 ? '机器量方' : '皮尺量方', desc: '' },
            { label: item.whetherSupportedCompensate ? '时效赔付' : '', desc: item.supportedCompensateDesc || item.compensationStandards },
            { label: item.whetherSupportCompensation ? '丢货赔付' : '不支持丢货赔付', desc: item.supportCompensationDesc || item.compensationStandards },
            { label: item.whetherGuaranteedDelivery ? '限时达' : '', desc: '' },
            { label: item.label1, desc: item.label1Desc },
            { label: item.label2, desc: item.label2Desc },
            { label: item.label3, desc: item.label3Desc },
          ]
          labelList = labelList.filter(v => v.label)
          item.labelList = labelList
          this.countData = {
            ...this.countData,
            carrierLogoUrl: item.carrierLogoUrl,
            carrierAbbr: item.carrierAbbr,
            labelList: item.labelList,
            aging: item.aging,
            agingType: item.agingType
          }
          this.BillItem = res.data.data
          console.log("this.BillItem: ", this.BillItem)
          this.getAttr()
          this.setDeliveryPrices()
          // console.log("11=", this.ProgType);
        })
        .catch((res) => { })
    },
    setDeliveryPrices() {
      // deliveryRegionPrices
      if (!this.countData.deliveryRegionPrices) {
        this.deliveryTheadData = []
        this.deliveryTableData = []
        return false
      }
      this.deliveryTheadData = this.countData.deliveryRegionPrices[0].map((c, i) => {
        return {
          label: c,
          prop: "name" + i,
        };
      });
      console.log("99999---", this.deliveryTheadData);
      let tableData = [];
      let list = this.countData.deliveryRegionPrices.map(item => item)
      list.splice(0, 1)
      // this.sortQuotationList(list);
      list.forEach((item, index) => {
        let obj = {};
        item.map((_item, index) => {
          obj["name" + index] = _item;
        });
        tableData.push(obj);
      });
      this.deliveryTableData = tableData;
      // this.deliveryTableData.splice(0, 1);
      console.log("tableData", this.deliveryTableData);
    },
    getAttr() {
      this.theadData = this.countData.productRegionPrices[0].map((c, i) => {
        return {
          label: c,
          prop: "name" + i,
        }
      })
      console.log("99999---", this.theadData)
      let tableData = []
      this.countData.productRegionPrices.forEach((item, index) => {
        let obj = {}
        item.map((_item, index) => {
          obj["name" + index] = _item
        })
        tableData.push(obj)
      })
      this.tableData = tableData
      this.tableData.splice(0, 1)
      console.log("tableData", this.tableData)
    },
    // 调到安全设置
    handleInfo() {
      this.$router.push(
        "/index/PersonalCenter/Personalindex/PersonalCenter/accountManage/UserManage"
      )
    },
    // 物流产品点击取消收藏
    handleCancelProductCollect(item) {
      console.log("handleCancelCollect", item)
      // return
      let data = {
        productOrCountryId: item.productId,
        refType: 1,
      }
      this.axios
        .post("/api/product/cancelConcernProductOrCountry", data)
        .then((res) => {
          if (res.data.code == 200) {
            this.citylist = res.data.datas;
            this.$message({
              type: "success",
              message: "已取消物流产品收藏",
            })
            this.getProductData("")
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            })
          }
        })
        .catch((res) => {
          this.$message.info("服务器繁忙")
        })
    },
    //   国家点击取消收藏
    handleCancelCollect(item) {
      console.log("handleCancelCollect", item)
      let data = {
        productOrCountryId: item.countryId,
        refType: 2,
      }
      this.axios
        .post("/api/product/cancelConcernProductOrCountry", data)
        .then((res) => {
          if (res.data.code == 200) {
            // this.citylist = res.data.datas;
            this.$message({
              type: "success",
              message: "已取消国家收藏",
            })
            this.getInit()
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            })
          }
        })
        .catch((res) => {
          // this.$message.info("服务器繁忙");
        })
    },
    // 点击国家查看详情
    checkPrice(val) {
      const route = this.$route
      const item = {
        ...val,
        fromSelectId: [null, val.cityId],
        toSelectId: [val.countryId, ''],
        isPrivateAddress: false,
        privateAddressType: val.privateAddressType,
        opening: true,
        fromCityInfo: {
          namec: val.cityNamec,
          code: val.cityCode
        }
      }
      console.log(...val,'999999999999999');
      if (!val.cityId) return this.$message.warning('缺少起运地参数')
      if (!val.countryId) return this.$message.warning('缺少目的地参数')
      if (!val.privateAddressType) return this.$message.warning('缺少目的地私人地址类型参数')

      this.$router.push({
        name: "queryPrice",
        query: {
          itemData: JSON.stringify(item),
          type: false,
          name: '收藏国家'
        },
      })

      this.$emit('cancelChose')
    },
    // 产品查看详情
    checkDetails (item, type, val) {
      console.log("item---", item)
      this.typeTips = val
      this.payType = type
      sendCustomerOperationRecord("查看详情",`产品名称:${item.productName}`, { productId: item.productId })
      if (item.polCityCode || item.countryCode) sendStatisticHotCountry(item.polCityCode || '', item.countryCode || '') // 热门国家城市埋点
      let url = ""
      url = `/FBAfee/queryQuotedPriceDetailInfo?productPriceHeaderId=${item.productPriceHeaderId}`
      this.axios
        .get(url)
        .then((res) => {
          if (res.data.code === 200) {
            this.ProgType = true
            this.countData = res.data.data || {}
            this.BillItem = res.data.data || {}
            console.log("this.BillItem: ", this.BillItem)
            this.getAttr()
            this.setDeliveryPrices()
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((res) => { })
    },
    //   查看详情
    handleDetail() {
      this.$router.push("/")
    },
    //   点击收藏取消
    followItem(item) {
      console.log("cancel", item)
    },
    changeimg(item) {
      // item.imgurl = item.whitePicUrl;
    },
    mouseLeave(item) {
      // item.imgurl = item.picUrl;
    },
    //   页面数据初始化
    getInit() {
      this.axios
        .get("/api/product/queryConcernCountryPriceInfo")
        .then((res) => {
          console.log("---", res)
          if (res.data.code == 200) {
            this.hotcityLIst = res.data.datas || []
            console.log(this.hotcityLIst, '111111111111111');
          } else {
            this.$message.info("服务器繁忙");
          }
        })
        .catch((res) => {
          this.$message.info("服务器繁忙");
        })
    },
    handleClick(tab, event) {
      // console.log(tab, event, 111);
      console.log("tab---", this.activeName)
      if (this.activeName == "first") {
        // 国家
        this.getInit()
      } else {
        // 物流产品
        this.getProductData("")
      }
    },
    // 下拉框名称查询
    getSelectNameList(val) {
      console.log(val);
      this.axios
        .get(
          `/api/product/getProductNameByName`
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.seleProductNameList = res.data.datas
            console.log(this.seleProductNameList, '8888888888888888888888');
          }
        })
    },
    // 下拉框code查询
    getSelectCodeList() {
      this.axios
        .get(
          `/api/product/getProductCodeByCode`
        )
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.seleProductCodeList = res.data.datas
          }
        })
    },

    // 点击查询
    getProductData(val) {
      console.log("this.concernTime", this.concernTime)
      this.axios
        .get(
          `/api/product/queryConcernProductPriceInfo?productName=${val || ""}&productCode=${this.productCode || ""}&concernStartTime=${this.concernTime ? this.concernTime[0] || "" : ''}&concernEndTime=${this.concernTime ? this.concernTime[1] || "" : ''}`
        )
        .then((res) => {
          console.log("product", res)

          if (res.data.code == 200) {
            // this.hotcityLIst = res.data.datas;
            const list = res.data.datas
            list.forEach(item => {
              let labelList = [
                { label: item.pickUpFlag ? '免费上门提货' : '', desc: '' },
                { label: item.goodsMeasurementMethod === 1 ? '机器量方' : '皮尺量方', desc: '' },
                { label: item.whetherSupportedCompensate ? '时效赔付' : '', desc: item.supportedCompensateDesc || item.compensationStandards },
                { label: item.whetherSupportCompensation ? '丢货赔付' : '不支持丢货赔付', desc: item.supportCompensationDesc || item.compensationStandards },
                { label: item.whetherGuaranteedDelivery ? '限时达' : '', desc: '' },
                { label: item.label1, desc: item.label1Desc },
                { label: item.label2, desc: item.label2Desc },
                { label: item.label3, desc: item.label3Desc },
              ]
              labelList = labelList.filter(v => v.label)
              item.labelList = labelList
            })
            this.productAll = list
            this.lineProductList = list
            // this.productList = res.data.datas
            // tables.slice((currentPage-1)*pagesize,currentPage*pagesize)
            this.productList = list.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)

            // this.productList = res.data.datas.slice(0, 10);
            // debugger
            // console.log("11111", this.productList)
            console.log("2322222",)
            this.total = list.length
          } else {
            this.$message.info("服务器繁忙")
          }
        })
        .catch((res) => {
          this.$message.info("服务器繁忙");
        })
    },
    // 查询
    handleSerach() {
      this.getProductData(this.product)
    },
    // 重置
    handleReset() {
      this.product = ""
      this.productCode = ''
      this.concernTime = []
      this.getProductData("")
    },
    // 全部取消收藏---产品
    handleCancelAll() {
      console.log("product-all", this.productList)
      this.$confirm("此操作将全部取消收藏, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post("/api/product/cancelAllConcernProduct")
            .then((res) => {
              console.log("cancel00", res)
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: "全部取消收藏",
                })
                this.getProductData("")
              } else {
                this.$message({
                  type: "error",
                  message: res.data.message,
                })
              }
            })
            .catch((res) => {
              this.$message.info("服务器繁忙")
            })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          })
        })
    },
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      // this.getInit();
      // this.getProductData()
      this.productList = this.productAll.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      // this.getInit();
      this.productList = this.productAll.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    },
    getHotcity() {
      this.axios
        .post(`/FBAfee/queryFBAHotState`)
        .then((res) => {
          this.hotcityLIst = res.data.datas
          this.hotcityLIst.forEach((item) => {
            this.$set(item, "imgurl", item.picUrl)
            if (item.countryCode == "US") {
              this.countryData = item
            }
          })
          let sourceName = this.$route.query.source
          if (sourceName) {
            this.countryData.toSelectId[1] = 19003818700
            this.setHotcity(this.countryData, false)
          }
        })
        .catch((res) => { })
    },
    setHotcity(item, type, name) {
      console.log("item: ", item)

      this.transportCodes = []
      this.isIndeterminate = false
      this.checkAll = true
      this.TransportationcheckLisy.forEach((item) => {
        this.transportCodes.push(item.value)
      })
      this.transportQuery = "ALL"
      this.searchType = type
      if (!item.opening)
        return this.$message({
          message: "暂未开通此线路，敬请期待",
          type: "warning",
          offset: "500",
        })
      this.thatALLcklist = item.fromSelectId
      if (item.toWarehouseInfo) {
        sessionStorage.setItem("toFABck", JSON.stringify(item.toWarehouseInfo))
      }

      sessionStorage.setItem(
        "whereCountryid",
        JSON.stringify(item.toSelectId[0])
      )
      this.whereIDlist = item.toSelectId
      this.whereCountryid = item.toSelectId[0] //目的国家id
      this.whereStoreid = item.toSelectId[1] //目的仓库id
      this.toStoreid = item.toSelectId[1]
      this.getGoodsTypeByCountryId(item.toSelectId[0]) //查询货物类型
      this.thatFBAcklist = item.toSelectId

      this.fromCityid = item.fromSelectId[1] //起运城市id
      sessionStorage.setItem("fromCityid", this.fromCityid)
      if (name == "US") {
        //暂时指定写死仓库id
        this.thatFBAcklist[1] = 19003818700
      }
      this.fromCityid = item.fromSelectId[1]
      this.fromProvinceid = item.fromSelectId[0]
      this.toCountryid = item.toSelectId[0] //目的国家id
      this.fromstoreName[0] = item.fromCityInfo.provinceName
      this.fromstoreName[1] = item.fromCityInfo.namec
      this.tocountryName = item.countryNamec
      this.tostoreName = item.toWarehouseInfo
        ? item.toWarehouseInfo.namec
        : "私人地址"
      let object = {
        namec: item.countryNamec,
        id: item.toSelectId[0], //目的国id
      }
      this.getStoredata(object)
      this.getFBAcount()
    },
    toggleIsSubscribeCountryStatus(val) {
      const params = {
        isSubscribeNewCountryPush: val,
        userId: this.$store.state.Authorization.userId
      }
      this.axios.post('/api/product/subscribeNewCountryPush', params).then(res => {
        console.log(res)
        if (res.data.code === 200) {
          this.$message.success(res.data.message)
        } else {
          this.$message.error(res.data.message)
          this.isSubscribeNewCountry = !val
        }
      })
    },
    getIsSubscribeCountryStatus() {
      const userId = this.$store.state.Authorization.userId
      this.axios.get(`/api/product/getSubscribeNewCountryPush/${userId}`).then(res => {
        if (res.data.code === 200) {
          this.isSubscribeNewCountry = res.data.data.isSubscribeNewCountryPush
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.BulkOrderbysea {
  width: 100%;
  height: calc(100% - 30px);
  box-sizing: border-box;
  overflow: hidden;
}

.BulkOrderbysea h4 {
  width: 100%;
  height: 24px;
  padding-top: 30px;
  padding-left: 31px;
  font-size: 24px;
  font-family: 'PingFang-SC-Bold';
  color: #343434;
}

.BulkOrderbysea .box-content {
  padding: 10px 30px;
}

.el-divider--horizontal {
  margin: 10px 0 20px !important;
}

.box-card {
  margin: 20px 0;
}

.invoiceDesc {
  width: 95%;
  margin: 20px 30px 0px;
  background-color: #fff1df;
  line-height: 20px;
  padding: 10px 8px;
}

.collect-body {
  margin: 30px;
  position: relative;
}

.collect-one {
  height: 600px;
  overflow: auto;
}

.collect-info {
  display: flex;
  justify-content: space-between;
  width: 98%;
}

.collect-body-all {
  width: 100%;
  margin-top: 0;
}

.Thicon {
  background: url('../../../assets/thiconi.png') no-repeat;
  background-size: 100% 100%;
  width: 15px;
  height: 15px;
  text-align: center;
  color: #c6c6c6;
  font-weight: bold;
  float: left;
  margin-right: 5px;
  margin-top: 2px;
}

.LR_center {
  display: flex;
  align-items: center;
}

.info-all-2-txt {
  color: #FF4D01;
  font-size: 28px;
  font-weight: 700;
  .symbol,
  .unit{
    font-size: 16px;
  }
}

.self_support {
  // width:80px;
  height: 26px;
  background-color: #FF4D01;
  border-radius: 5px;
  text-align: center;
  line-height: 26px;
  color: #fff;
  margin-right: 15px;
  padding: 0 10px;
}

.info-left-1 {
  margin-bottom: 12px;
}

.info-all {
  width: 100%;
  display: flex;
}

.info-all-1 {
  width: 60%;
  margin-left: 20px;
}

.info-all-2 {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-all-3 {
  width: 20%;
}

.info-all-3 {
  display: flex;
  align-items: center;
  justify-content: center;
}

.Gotobtn {
  cursor: pointer;
  width: 170px;
  height: 50px;
  background: #FF4D01;
  border-radius: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 16px;
  font-family: PingFang SC;
  color: #ffffff;
}

.prodectSty {
  display: flex;
  margin-top: 15px;
  color: #c1c1c1;
  justify-content: right;
}

.checkbox {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

.Zxicon {
  background: url('../../../assets/zx.png') no-repeat;
  background-size: 100% 100%;
  width: 16px;
  height: 16px;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
  float: left;
  margin-right: 2px;
  margin-top: 3px;
}

.Xqicon {
  background: url('../../../assets/zx.png') no-repeat;
  background-size: 100% 100%;
  width: 16px;
  height: 16px;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
  float: left;
  margin-right: 2px;
  margin-top: 3px;
}

.Bom_style {
  width: 95px;
  height: 30px;
  background: #f9c158;
  border-radius: 15px;
  float: left;
  margin-right: 30px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  color: #ffffff;
  font-size: 14px;
  border: 1px solid #fff !important;
}

.info-left-3 {
  margin-top: 10px;
}

.hotlist {
  width: 100%;
  float: left;
}

.Hotcounter {
  width: 20%;
  box-sizing: border-box;
  float: left;
  padding: 0 10px;
  height: 140px;
  margin-bottom: 18px;
  position: relative;
  border-radius: 30px;
}

.Hotcounter>>>.el-card__body {
  padding: 20px;
}

.SlowAlterBac {
  transform: translateZ(0);
  position: relative;
  transition-property: color;
  transition-duration: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
}

.SlowAlterBac:before {
  content: '';
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  opacity: 0.5;
  transform-origin: 110px 0;
  transform: scaleX(0);
  transition: transform 0.3s ease-out;
  z-index: 9999;
  /* border-radius: 60px 0 0 60px; */
}

.SlowAlterBac:hover,
.SlowAlterBac:focus,
.SlowAlterBac:active {
  color: white;
}

.SlowAlterBac:hover:before,
.SlowAlterBac:focus:before,
.SlowAlterBac:active:before {
  transform: scaleX(1);
}

.look-info,
.cancel-collect {
  display: none;
}

.SlowAlterBac:hover .look-info {
  display: block;
  z-index: 999999;
  color: white;
  width: 400px;
  height: 140px;
  position: absolute;
  left: 40%;
  top: 43%;
}

.look-all {
  display: flex;
}

.SlowAlterBac:hover .cancel-collect {
  display: block;
  z-index: 999999;
  color: white;
  position: absolute;
  top: 20px;
  right: 30px;
}

.imgs {
  width: 28px;
  height: 28px;
  margin-right: 10px;
}

.label-1 {
  display: flex;
  align-items: center;

  span {
    font-size: 18px;
  }
}

.no-data {
  display: flex;
  justify-content: center;
  margin-top: 100px;
  flex-wrap: wrap;
}

.content {
  width: 100%;
  display: flex;
  justify-content: center;

  span {
    margin-top: 30px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #333333;
  }
}

.collect-body>>>#tab-first {
  height: 50px;
}

.product-star {
  margin-left: 20px;
  cursor: pointer;
}

.pushCount {
  font-size: 13px;
  color: #FF4D01;
  cursor: pointer;
}

.pushCount:hover {
  text-decoration: underline;
}

.Parent {
  position: relative;
}

.detailsText {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  color: #c1c1c1;
}

.offlineSignWrap {
  float: right;
}
.unfollowAll {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #141414;
  line-height: 20px;
  cursor: pointer;
  z-index: 1;;
  &:hover {
    color: lighten(#141414, 30%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/personalInfo/MyCollect.vue